import * as React from "react";
import {Collapse, Button, Card, Divider, NumericInput, Tooltip} from "@blueprintjs/core";
import { Icon, Intent } from "@blueprintjs/core";
import { FlexJustify, FlexLeft, FlexRight } from "../../../common/fragments/Flex";
import { BlockView, BlockVariant } from "common/views/block/BlockView.view";
import HeadingView from "common/views/heading/Heading.view";
import { FlexColumn } from "./CustomStyles";
import OrganizationEnrollments from "../entities/OrganizationEnrollments";
import OrganizationDistribution from "./OrganizationDistribution";
import { ButtonView, ButtonVariant } from "common/views/button/Button.view";
import { map } from "async";
import { ID } from "common/entities/IEntity";
import { ForumToaster } from "panels/forum/forumActions";
import ServiceRegistry from "core/util/ServiceRegistry";
import { SeatAssignment } from "../entities/SeatAssignment";
import Loading from "common/fragments/Loading";
import { isEmpty } from "core/util/ArrayUtils";
import Label from "core/components/label/Label";

export interface ICollapseState {
    isOpen?: boolean;
};

export interface ISeatsPurchased {
    value?:string|number;
    color?:string;
    isOpen?: boolean;
    organizationEnrollments:OrganizationEnrollments;
    reload:any
}

class SeatDistribution {
	public id: ID;
    enrollLimit: number;
    enrollCount:number;
	constructor(id: ID,enrollCount:number, enrollLimit: number) {
        this.id = id;
        this.enrollCount= enrollCount;
        this.enrollLimit = enrollLimit;
	}
}

class CourseOrganization{
    courseName:String;
    organizationName:String;
    constructor(courseName:String, organizationName: String) {
        this.courseName =courseName,
				this.organizationName=organizationName
	}
}

export default class SeatsPurchased extends React.PureComponent<ISeatsPurchased> {

		public state = {
				isOpen: false,
				seatMap:map,
				isloading:false
		};

		seatMap = new Map();

		public render() {
				let up = <Icon icon="chevron-up" iconSize={16}></Icon>;
				let down = <Icon icon="chevron-down" iconSize={16}></Icon>;

				const buttonStyle = {
						display:'flex',
						margin: '0 auto',
						justifyContent: 'center',
						alignItems:'center',
						width:'100%',
				}

				const divStyle = {
						display:'flex',
						flexDirection:'column',
						alignItems:'center',
						justifyContent:'center',

				}

				const tooltipContent= 'Distribute seats will best split your amount of seats between all of your Institutions. If there is not an even number of seats it will divide the seats evenly until it reaches the last Institution.';
				return (
				<div>
							{this.state.isloading ?
										<Loading key="loading" /> : null
							}
						<BlockView variant={BlockVariant.CARD_HEADER} viewKey="cartItems">

						<form>
								<Card style={{display:'flex', flexDirection:'row', flexWrap:'wrap', justifyContent: 'space-between', alignItems:'center', padding: 0}}>
										<FlexLeft style={{width: '70%', padding: 20}}>
												<HeadingView viewKey="heading" style={{fontSize: 24, fontWeight: 300, textAlign: 'left'}}>
														{this.props.organizationEnrollments.item.name}
												</HeadingView>
										</FlexLeft>
										<FlexLeft style={{textAlign: 'center', backgroundColor: '#f4f4f4', height: '100%', alignItems: 'center', width: '30%', padding: 20}}>
												<div style={{paddingRight: 25, borderRight: '2px solid #e0e0e0'}}>
														<h3 style={{fontSize: 18}}>{this.props.organizationEnrollments.seatsPurchased}</h3>
														<p style={{fontWeight: 200, fontSize: 12, marginBottom: 0}}>SEATS(S) PURCHASED</p>
												</div>
												<Divider style={{borderColor: '#e0e0e0', borderRight: '1px solid #e0e0e0', borderLeft: '1px solid #e0e0e0'}}></Divider>
												<div style={{marginLeft: 25}}>
														<h3 style={{fontSize: 18}} >{`${this.props.organizationEnrollments.seatsRemaining < 0 ? 0 :
														 this.props.organizationEnrollments.seatsRemaining}`}</h3>
														<p style={{fontWeight: 200, fontSize: 12, marginBottom: 0}}>SEATS(S) REMAINING</p>
												</div>
										</FlexLeft>
								</Card>
								<div style={{margin: '0 auto', height: 0, display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 10}}>
										<Button onClick={this.handleClick} style={{position: 'relative', bottom: 0, zIndex: 10}}>
												{this.state.isOpen ? down : up}
										</Button>
								</div>
								<div style={{zIndex: 0}}>
								<Collapse isOpen={this.state.isOpen}>
										<Card style={{display: 'flex', flexDirection: 'row', flexWrap: 'wrap', justifyContent: 'space-between', alignItems: 'center', zIndex: 0, padding: 0}}>
												<FlexLeft style={{width: '70%', padding: 20, marginTop: 15}}>
														<FlexColumn style={{width: '100%', display: 'flex', flexDirection: 'column'}}>
																<FlexJustify style = {{borderBottom: '1px solid #9d9d9d', width: '100%', marginBottom: 10}}>
																		<p style={{color: '#9d9d9d', fontSize: 12}}>INSTITUTIONS</p>
																		<p style={{justifyContent: 'flex-end'}}><span style={{color: "#FE1A61"}}>
																		{`${this.props.organizationEnrollments.seatsRemaining < 0 ? 0 :
																		this.props.organizationEnrollments.seatsRemaining}`}/{this.props.organizationEnrollments.seatsPurchased} </span>Seat(s) Remaining</p>
																</FlexJustify>

																{!this.state.isloading && this.props.organizationEnrollments.enrollmentDetails.map((enrollmentDetails) => {
																				return  <OrganizationDistribution enrollmentDetails={enrollmentDetails}
																				handleInputChange={this.handleInputChange}/>;
																})}
																<FlexJustify style={{justifyContent: 'flex-end', alignItems: 'center'}}>
																		<Tooltip content={tooltipContent}>
																				<Icon icon='info-sign' iconSize={16} color='gray'></Icon>
																		</Tooltip>

																		<ButtonView variant={ButtonVariant.MINIMAL} onClick={(e) => this.distributeSeatsEvenly(e)}
																						viewKey="seats-distribute-evenly" >
																				<Label k="seats.distribute-evenly" v="DISTRIBUTE SEATS EVENLY" />
																		</ButtonView>

																</FlexJustify>

														</FlexColumn>
												</FlexLeft>


												<FlexLeft style={{flexDirection: 'column', textAlign: 'center', height: '100%', alignItems: 'center', justifyContent: 'center', width: '30%', padding: 20}}>
																<ButtonView variant={ButtonVariant.PRIMARY} button
																					onClick={(e) => this.confirmSeats(e)}
																					viewKey="confirms-seats">
																				<Label k="confirms-seats" v="CONFIRM SEATS" />
																</ButtonView>
												</FlexLeft>
										</Card>


								</Collapse>
								</div>
								</form>
						</BlockView>
				</div>
				);
		}

		private handleClick = () => {
				this.setState({ isOpen: !this.state.isOpen });
		}

		private distributeSeatsEvenly(e) {
				e.preventDefault();
				this.setState({isloading: true});

				if(this.props.organizationEnrollments.seatsRemaining < 1) {
						ForumToaster.show({
								intent: Intent.WARNING,
								message: "Seats Not Available For Distribution"
						});
						this.setState({isloading: false});
						this.props.reload(true);
						return;
				}

				const totalOrganization = this.props.organizationEnrollments.enrollmentDetails.length;
				var seatsRemaining=this.props.organizationEnrollments.seatsRemaining;
				const div = Math.floor(seatsRemaining / totalOrganization);
				const evenDistribution = [];
				this.props.organizationEnrollments.enrollmentDetails.map((details, index) => {
						const totalSeats = div + details.enrollLimit;
						evenDistribution.push({index, id: details.id, enrollLimit: totalSeats});
				});
				seatsRemaining = seatsRemaining - (div * totalOrganization);

				evenDistribution.map((detail, index) => {
						if(index < seatsRemaining) {
						const totalSeats =detail.enrollLimit + 1;
						detail.enrollLimit = totalSeats;
						evenDistribution.splice(index, 1, detail);
						}
				});

				evenDistribution.map((detail, index, array) => {
						const s = { id: detail.id, enrollLimit: detail.enrollLimit } as any;
						ServiceRegistry.getMutationService().update(s, SeatAssignment)
								.then((res) => {
										if (index === array.length - 1) {
												ForumToaster.show({
														intent: Intent.SUCCESS,
														message: "Seats Evenly Distributed"
												});
												this.setState({isloading: false});
												this.props.reload(true);
												return;
										}
								}).catch((err) => {
										console.error(err);
										this.setState({isloading: false});
								});
					});

					
		}

		private confirmSeats(e) {
				e.preventDefault();
				this.setState({isloading: true});
				const seatAssignments = [];
				const courseOrganization = [];
				let totalSeats: number = 0;
				this.props.organizationEnrollments.enrollmentDetails.map((details) => {
						const quantity = this.seatMap.get(this.props.organizationEnrollments.item.id + details.organization.id);
						if (quantity !== undefined) {
								if(quantity < details.enrollCount) {
										courseOrganization.push(new CourseOrganization(this.props.organizationEnrollments.item.name, details.organization.name));
								}
								totalSeats += this.seatMap.get(this.props.organizationEnrollments.item.id + details.organization.id);
								seatAssignments.push(new SeatDistribution(details.id, details.enrollCount, quantity));
						} else {
								totalSeats += details.enrollLimit;
						}
				});

				if(!isEmpty(courseOrganization)) {
						this.setState({isloading: false});
						courseOrganization.map((co) => {
								ForumToaster.show({
										intent: Intent.WARNING,
										message: `Quantity should be greater than the subscribed count for course ${co.courseName}
                    Organization ${co.organizationName}`
								});
						});
						return;
				}

				if (totalSeats > this.props.organizationEnrollments.seatsPurchased) {
						this.setState({isloading: false});
						ForumToaster.show({
								intent: Intent.DANGER,
								message: "Total seat count exceeds purchased limit"
						});
				} else if(isEmpty(seatAssignments)) {
						this.setState({isloading: false});
						ForumToaster.show({
								intent: Intent.WARNING,
								message: "No seat changes"
						});
				} else {
						seatAssignments.map((seatAssignment, index, array) => {
								const s = { id: seatAssignment.id, enrollLimit: seatAssignment.enrollLimit,
														enrollCount: seatAssignment.enrollCount} as any;
								ServiceRegistry.getMutationService().update(s, SeatAssignment)
										.then((res) => {
												if (index === array.length - 1) {
														ForumToaster.show({
																intent: Intent.SUCCESS,
																message: "Seats Distributed Successfully"
														});
														this.setState({isloading: false});
														this.props.reload(true);
												}
										}).catch((err) => {
												console.error(err);
												this.setState({isloading: false});
										});
						});
				}
		}

		private handleInputChange = (e, organizationId) => {
				this.seatMap.set(this.props.organizationEnrollments.item.id + organizationId, e.valueOf());
		}

}




// WEBPACK FOOTER //
// ./src/panels/checkout/components/SeatsPurchased.tsx